module.exports = __webpack_public_path__ + "img/intro1_en.54633826.jpg";